import React from 'react';
import { Button } from '@cuemath/web-comps';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { openModal } from 'actions/modal';
import { COLORS } from '@cuemath/comps';

const ButtonWrapper = styled(Button)`
  height: 32px;
`;

const StudentTransferInit = () => {
  const dispatch = useDispatch();

  const onTransferStudentClick = () => {
    dispatch(
      openModal('student-transfer-initiate-form', {
        blocking: true,
        transparent: false,
        size: 'custom',
        width: '512px',
        radius: '16px',
        modalZIndex: 1000,
        backdropFilter: true,
        backdropFilterData: {
          blurValue: 'blur(20px)',
          bgColor: COLORS.COLA_LIGHTER,
        },
        closeIconAttributes: { placeCloseIcon: true },
      }),
    );
  };

  return (
    <ButtonWrapper
      size="small"
      label="Transfer student"
      onClick={onTransferStudentClick}
    />
  );
};

export default StudentTransferInit;
